<template>
    <div class="sidebar fl br5 bgw">
        <div class="sidebar-title mcolor tcenter bg-main prelative">
            <span :class="newsType[root]['icon']" class="iconfont fs28 vcenter mr5 fs26">&nbsp;</span>
            <span class="fs22 fbold vcenter">{{newsType[root]['stitle']}}</span>
        </div>
        <div class="sidebar-alist fs16 tcenter">
            <div v-for="(item,key) in sideBar" 
                :key="key" @click="controlSideBar"
                :class="parent && parent == key ? 'active' : '' " 
                class="pa" >
                <template v-if="typeof item !== 'object'">
                    <a v-if="newsType[key.trim()].link"  :href="newsType[key.trim()]['link']" 
                        target="_blank"
                        class="sidebar-a before prelative dblock fs18 tc6 pl25 pr20 dflex jc-between tleft">
                        {{item}}
                    </a>
                    <router-link v-else :to="newsType[key]['to']" 
                        class="sidebar-a before prelative dblock fs18 tc6 pl25 pr20 dflex jc-between tleft">
                        <span class="t-hidden">{{item}}</span>
                        <span class="iconfont icon-xiangyoujiantou"></span>
                    </router-link>
                </template>
                <div v-else  class="sidebar-a before prelative dblock fs18 tc6 pl25 pr20 dflex jc-between tleft cpointer">
                    <span class="t-hidden">{{newsType[key.trim()]['stitle']}}</span>
                    <span class="iconfont icon-xiangyoujiantou"></span>
                </div> 
                <div v-if="typeof item == 'object'" 
                     class="alist sidebar-a before prelative dblock fs16 tc6 tleft">
                    <router-link v-for="(item2, key2) in item" 
                        :key="key2"  
                        :to="newsType[key2.trim()].to" 
                        :class="key2.trim() == id ? 'active' : ''"
                        class="sa dblock prelative pl40 pr20 cpointer">
                        <span v-if="key2.trim()== id" class="iconfont icon-lingxing pabsolute"></span>
                        {{item2}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            root: '',
            parent: '',
            newsType: {},
            sideBar: {},
            activeId: 0,
            id: ''
        }
    },
    watch: {
        $route: {
            handler(val, oldval) {
                this.getSideBar()
            },
            deep: true,// 深度观察监听
            immediate: true
        }
    },
    create(){
    },
    methods: {
        getSideBar() {
            let sParams = this.$route.params
            
            let query = this.$route.query
            
            let id = query && query.typeId ? query.typeId : (sParams.id ? sParams.id : 0)
            console.log(id,id);
            if(id){
                let {newsType, menu} = this.$params
                 
                this.root = newsType[id].root 
                console.log(11,this.root);
                this.parent =  newsType[id].parent
                this.sideBar = menu[this.root]
                console.log(22,this.$params);
                //console.log('sss');
                console.log('2212212121',this.sideBar);
                this.newsType = newsType
                this.id = id
            }
        },
        controlSideBar(e){
            var active = document.querySelector('.pa.active')
            var target = e.currentTarget
            if(active && active == target)
                return
            if(active)
               active.classList.remove('active')
            target.classList.add('active')
        }
    }
}
</script>
<style scoped>
    .lms{
        border: 1px solid #b6c4e7;
        border-radius: 2px;
        background: linear-gradient(to bottom, #fff, #f9f6f6);
    }
    .lms:hover{
        background: #fff;
        box-shadow: 0 0 15px #eee;
        font-weight: bold;
    }
    .lms:hover .img{
        left: 2px;
    }
    .pa .alist{
        transform-origin: center top;
        opacity: 0;
        height: 0;
    }
    .pa .alist .sa{
        margin: 0 1px 0 4px;
        padding: 0 10px 0 60px;
    }
    .pa .alist .sa.active{
        font-weight: bold;
    }
    .pa .sidebar-a:not(.alist):hover,
    .pa .sa:hover{
        background: #d4e5fc;
    }
    .pa.active .alist{
        transition: all .5s;
        height: auto;
        opacity: 1;
    }
    .pa.active .sidebar-a{
        background: #f9f6f6;
    }
    .pa.active .sidebar-a::before{
        width: 3px;
        height: 100%;
        background: var(--mcolor);
        left: 0;
    }
    .pa.active .icon-xiangyoujiantou{
        transform: rotate(90deg);
    }
    
    .sidebar .sidebar-title>span.iconfont{
        left: 20px;
    }
    .icon-lingxing{
        left: 35px;
    }

</style>